<template>
  <div class="printLabel column-me">
    <div class="row-me overflow-auto" v-dragscroll.x="true">
      <div class="column-me row-center margin-right30" @click="clickTab(item)" v-for="(item,index) in personArray"
           :key="index">
        <div class="tab-title" :class="{'tab-title-active':selectItem.id===item.id}">{{ item.patientName }}</div>
        <div class="tab-line" :class="{'tab-line-active':selectItem.id===item.id}"></div>
      </div>
    </div>
    <div class="line-grey-heng"></div>

    <!--汤剂-->
    <div class="flex1 overflow-auto column-me" v-if="selectItem.val==='t'||selectItem.val==='d'||selectItem.val==='z'">
      <div class="row-me row-center margin-top30 padding-bottom20">
        <div>打印数量：</div>
        <div class="width200">
          <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.doseNums"
                    @input="numberChange"></el-input>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left50" @click="clickPrint">
          打印
        </div>
      </div>
      <div :id="'print'+selectItem.id" class="printDiv flex1 overflow-auto" v-dragscroll.y="true"
           v-if="!this.$method.isEmptyOrZero(selectItem.doseNums)">
        <div class="column-me" v-for="(item,index) in Number(selectItem.doseNums)"
             :key="index" style="page-break-after: always;">
          <div style="font-size: 12px;word-break: keep-all;">
            <svg :id="'barcode'+selectItem.id"></svg>
            <div class="row-me row-center">
              <div style="font-weight: bold;width: 80px;" class="line1">
                {{ selectItem.patientName }}
              </div>
              <div class="row-me row-center flex1 flex-sb">
                <div>{{ selectItem.sex }}</div>
                <div v-if="!this.$method.isEmpty(selectItem.age)">
                  {{ selectItem.age }}岁
                </div>
                <div style="width: 80px;" class="line1">{{ selectItem.takeMethod }}</div>
              </div>
            </div>
            <div>{{ selectItem.mechName }}</div>
            <div>
              包数：{{
                (Number(selectItem.doseNumsOld) * Number(selectItem.frequency.replace(/[^0-9]/g, ""))) + '包(' + selectItem.doseNumsOld + '天*' + selectItem.frequency.replace(/[^0-9]/g, "") + '次)'
              }}
            </div>
            <div>包装量：{{ selectItem.packageNums }}</div>
            <div>日期：{{ nowDate }}</div>
            <div>医院单号：{{ selectItem.prescriptionNumber }}</div>
          </div>
        </div>
      </div>
    </div>

    <!--其他剂型-->
    <div class="flex1 overflow-auto column-me" v-else>
      <div class="row-me row-center margin-top30">
        <div>打印数量：</div>
        <div class="width200">
          <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.doseNums"
                    @input="numberChange"></el-input>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left50" @click="clickPrint">
          打印
        </div>
      </div>
      <div class="row-me row-center margin-top20 padding-bottom20">
        <div>&emsp;&emsp;数量：</div>
        <div class="width150">
          <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.packageNumsInt"
                    @input="selectItem.packageNumsInt=this.$method.checkInput(selectItem.packageNumsInt,0)"></el-input>
        </div>
        <div style="margin-left: 20px;">单位：</div>
        <div class="width150">
          <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.unit"></el-input>
        </div>
      </div>
      <div :id="'print'+selectItem.id" class="printDiv flex1 overflow-auto" v-dragscroll.y="true"
           v-if="!this.$method.isEmptyOrZero(selectItem.doseNums)">
        <div class="column-me row-center" v-for="(item,index) in Number(selectItem.doseNums)"
             :key="index" style="margin-bottom: 20px;page-break-after: always;">
          <div style="font-size: 25px;margin-top: 20px;">
            <div class="line1">{{ selectItem.patientName }}</div>
            <div class="line1" style="margin-top: 10px;">
              {{ selectItem.processType }}/{{ selectItem.packageNumsInt }}{{ selectItem.unit }}
            </div>
          </div>
        </div>
      </div>

    </div>
    <button v-show="false" id="printLabelId" v-print="printContent"></button>
  </div>
</template>

<script>
let JsBarcode = require('jsbarcode')
export default {
  components: {},
  props: {
    persons: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectItem: {},
      personArray: this.persons,
      printContent: {
        id: "", // 打印的区域
        preview: false, // 预览工具是否启用
      },
      nowDate: '',//当前日期
    }
  },
  // 侦听器
  watch: {
    "selectItem.doseNums"(val, oldVal) {
      if (this.selectItem.val === 't' || this.selectItem.val === 'd' || this.selectItem.val === 'z') {
        if (!this.$method.isEmptyOrZero(val)) {
          this.$nextTick(() => {
            //条形码
            JsBarcode("#barcode" + this.selectItem.id, this.selectItem.orderNo, {
              lineColor: "#000000",
              width: 1.3,
              height: 12,
              fontSize: 12,
              textAlign: 'left',
              displayValue: true,
              margin: 0,
            });
          })
        }
      }
    },
  },
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {
    this.nowDate = this.$method.getNowDate()
  },
  // html加载完成后执行。
  mounted() {
    for (let i = 0; i < this.personArray.length; i++) {
      let item = this.personArray[i]
      if (i === 0) {
        item.unit = '袋'
        item.doseNumsOld = item.doseNums
        this.selectItem = this.$method.deepClone(item)
      }
    }
  },
  // 事件方法执行
  methods: {
    numberChange(e) {
      this.selectItem.doseNums = this.$method.checkInput(this.selectItem.doseNums, 0)
      if (Number(this.selectItem.doseNums) === 0) {
        this.selectItem.doseNums = ''
      }
      if (Number(this.selectItem.doseNums) > 50) {
        this.selectItem.doseNums = this.selectItem.doseNums.substring(0, this.selectItem.doseNums.length - 1)
      }
    },
    clickTab(item) {
      item.unit = '袋'
      item.doseNumsOld = item.doseNums
      this.selectItem = this.$method.deepClone(item)
      if (this.selectItem.val === 't' || this.selectItem.val === 'd' || this.selectItem.val === 'z') {
        if (!this.$method.isEmptyOrZero(this.selectItem.doseNums)) {
          this.$nextTick(() => {
            //条形码
            JsBarcode("#barcode" + this.selectItem.id, this.selectItem.orderNo, {
              lineColor: "#000000",
              width: 1.3,
              height: 12,
              fontSize: 12,
              textAlign: 'left',
              displayValue: true,
              margin: 0,
            });
          })
        }
      }
    },
    clickPrint() {
      if (this.$method.isEmptyOrZero(this.selectItem.doseNums)) {
        this.$message.error('请输入打印数量')
        return
      }
      if (this.$method.isEmptyOrZero(this.selectItem.packageNumsInt)) {
        this.$message.error('请输入数量')
        return
      }
      if (this.$method.isEmpty(this.selectItem.unit)) {
        this.$message.error('请输入单位')
        return
      }
      this.printContent.id = 'print' + this.selectItem.id
      document.getElementById("printLabelId").click();
    },
  },
}
</script>

<style lang="scss" scoped>
/*去除页眉页脚*/
@page {
  size: auto;
  /* auto is the initial value */
  margin: 3mm;
  /* this affects the margin in the printer settings */
}

html {
  background-color: #FFFFFF;
  margin: 0;
  /* this affects the margin on the html before sending to printer */
}

body {
  border: solid 1px blue;
  margin: 10mm 15mm 10mm 15mm;
  /* margin you want for the content */
}

/*去除页眉页脚*/
.printLabel {
  width: 500px;
  height: 100%;
  font-size: 18px;
  margin: 0 30px;

  .line-grey {
    width: 100%;
    height: 2px;
    background: #F3F3F3;
  }
}
</style>
